import React from 'react';
import PropTypes from 'prop-types'

import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import {List} from 'material-ui/List';
import Checkbox from 'material-ui/Checkbox';

import Uploader from '../../util/uploader';
import Fetcher from '../../util/fetcher';
import StepProps from '../../constants/StepProps';
import numeral from 'numeral';
import AmazingList from './AmazingList';

// import Map from 'material-ui/svg-icons/maps/map';


const styles = {
  flexBox: {
    display: 'flex',
    flexFlow: 'row wrap',
  },
  flexLeft: {
    flex: '2 0 0',
    margin: '8px 8px 8px 0px',
  },
  flexRight: {
    flex: '1 0 0',
    margin: '8px 0px 0px 0px',
  },
  uploadButton: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
}

function perThousandDots(num) {
  // return  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return numeral(num).format('(0,0)')
}
// function onlyUnique(value, index, self) { 
//   return self.indexOf(value) === index;
// }

// const mapContinentName = {
//   AS: "Asia", 
//   EU: "Europe", 
//   AN: "Antarctica", 
//   OC: "Oceania", 
//   AF: "Africa", 
//   SA: "South America", 
//   NA: "North America", 
// }

class PoiStepSourceForm extends React.Component {
  static propTypes = StepProps;
  static contextTypes = {
    dataset: PropTypes.string.isRequired,
    datasetLocation: PropTypes.string.isRequired,
    firebaseToken: PropTypes.string.isRequired,
  };

  constructor(props, context) {

    super(props, context);

    this.state = {
      // continents: [ "AS", "EU", "AN", "OC", "AF", "SA", "NA" ],
      // selectedContinents: [],
      // toggleContinents: false,
      selectedPois: {},
      inputMethod: 'from_poi',
      showColumnSettings: false,
      fromFile: null,
      selectedFileName: '...',
      selectedSum: 0,
    };
    this.handleFileSelect = this.handleFileSelect.bind(this);
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    this.handleValidation(nextState);
  }
  
  componentDidMount() {
    this.handleValidation(this.state);
  }

  // render region selection list
  // !!!TODO: make the (nested) list thing reusable
  // Temp disabled

  // continentList() {
  //   const continentList = this.state.continents.sort();
  //   const continentItems = continentList.map((value, index) => (
  //     <ListItem
  //       key={index + 1}
  //       primaryText={mapContinentName[value]}
  //       initiallyOpen={false}
  //       leftCheckbox={<Checkbox 
  //         checked={this.state.selectedContinents.indexOf(value) !== -1}
  //         onCheck={this.onContinentSelectionChange(value)}
  //       />}
  //     />
  //   ));
  //   continentItems.unshift(
  //     <ListItem
  //       key={0}
  //       primaryText={'Select all'}
  //       rightToggle={<Toggle 
  //         toggled={this.state.toggleContinents}
  //         onToggle={this.toggleContinentSelectAll}
  //       />}
  //     />
  //   );
  //   return continentItems;
  // }

  // onContinentSelectionChange = (continent) => (event, isInputChecked) => {
  //   let {selectedContinents} = this.state;

  //   selectedContinents = selectedContinents.filter((value, index) => value === continent ? false : true);

  //   if (isInputChecked) {
  //     selectedContinents.push(continent);
  //   }

  //   // Update the `SELECT ALL/NONE` button to match the new selection
  //   let allSelected = this.state.continents.length > selectedContinents.length ? true : false;
  //   const toggleContinents = !allSelected;

  //   this.setState({
  //     selectedContinents,
  //     toggleContinents,
  //   });
  // }

  // toggleContinentSelectAll = (event) => {
  //   let {toggleContinents, selectedContinents} = this.state;
    
  //   selectedContinents = toggleContinents ? [] : this.state.continents ;
  //   toggleContinents = !toggleContinents;

  //   this.setState({
  //     toggleContinents,
  //     selectedContinents,
  //   });
  // }



  handlePoiUpdate = (selectedPois, selectedSum) => {
    this.setState({selectedPois, selectedSum});
    // this.sumSelectedPois(selectedPois)
  }
  
  
  // handlers for file upload
  handleShowColumnSettingsChange = (event, isChecked) =>
    this.setState({
      showColumnSettings: isChecked,
      inputMethod: isChecked? 'from_file': 'from_poi',
    }, this.validateResults);

  
  handleFileSelect(e) {
    let selectedFileName = (e.target.files[0] && e.target.files[0].name) || '...';
    this.setState({
      selectedFileName,
      fromFile: e.target.files[0],
    }, this.validateResults);
  }

  // validations
  validateResults(props = this.props, state = this.state) {
    let valid = false;
    if (state.showColumnSettings) {
      valid = !!state.fromFile;
    } 
    
    props.onValidationChange(valid);
  }

  handleValidation(state) {
    // let prevFormValid = this.isFormValid(this.state);
    let nextFormValid = this.isFormValid(state);
    // If none are selected, we cannot continue.
    if (nextFormValid !== this.prevFormValid) {
      this.props.onValidationChange(nextFormValid);
      this.prevFormValid = nextFormValid;
    }
  }

  isFormValid(state = this.state) {
    const { selectedPois } = state;
    return Object.keys(selectedPois).length > 0 ;
  }

  complete() {
    // Create form commands and send this to the back-end
    const data = {};
    let uploadAction = '';
    let { fromFile, selectedPois } = this.state;

    switch (this.state.inputMethod) {
      case 'from_file':
        data.file = fromFile;
        uploadAction = 'file';
        break;
      case 'from_poi':
        data.pois = selectedPois;
        data.continents = [];
        break;
      default:
        break;
    }

    if (this.state.inputMethod === 'from_file') {
      Uploader.init(this.context.firebaseToken)
        .uploadFile(uploadAction, data, this.context.dataset, this.context.datasetLocation, 'poi')
        .then(this.props.onStepCompleteSuccess)
        .catch(this.props.onStepCompleteFailed);
    } else {
      Fetcher.init(this.context.firebaseToken)
        .poiSelect(data, this.context.dataset)
        .then(this.props.onStepCompleteSuccess)
        .catch(this.props.onStepCompleteFailed);
    }
  }

  render() {

    // Styles to animate appearance of column settings panel
    let columnSettingsStyle = {
      height: this.state.showColumnSettings ? "auto" : 0,
      opacity: this.state.showColumnSettings ? 1: 0,
      transform: this.state.showColumnSettings ? "translateY(0)" : "translateY(-10px)",
      overflow: "hidden",
      transition: "opacity 0.5s ease, transform 0.5s ease",
      padding: 40,
    }
    
    return (
      <div>
        <div style={styles.flexBox}>
          <div style={styles.flexLeft}>
            <Paper zDepth={1} className="ContentSpacing">
                <div style={styles.flexBox}>
                  <h3>POI segments</h3>
                  <p>This service allows you to extract an audience from the POI-audience dataset, 
                    using POI or lat-long data.
                    The output that is generated can be amplified using our amplification service, 
                    in order to connect the deviceIDs to other IDs in your graph.</p>
                </div>
                  <List>
                    {/* Temp Disabled 
                    <ListItem
                      leftIcon={<Map />}
                      primaryText="Region"
                      initiallyOpen={false}
                      primaryTogglesNestedList={true}
                      nestedItems={this.continentList()}
                    /> */}
                    <AmazingList onUpdate={this.handlePoiUpdate}/>
                  </List>
            </Paper>
          </div>
          <div style={styles.flexRight}>
            <Paper zDepth={1} className="ContentSpacing">
              <h3>Geo input</h3>
              <Checkbox
                label="Upload my own geolocation data"
                onCheck={ this.handleShowColumnSettingsChange }
              />
              <div style={columnSettingsStyle}>
                <RaisedButton
                  label="Select file"
                  labelPosition="before"
                  style={styles.button}
                  containerElement="label"
                >
                  <input type="file"
                    accept=".csv, .csv.gz, .tsv, .tsv.gz"
                    onChange={this.handleFileSelect}
                    style={styles.uploadButton}
                  />
                </RaisedButton>
                <br />
                <p><i>{this.state.selectedFileName}</i></p>
              </div>
              <h3>Selected POIs: {perThousandDots(this.state.selectedSum)}</h3>
            </Paper>
          </div>
        </div>
      </div>
    )
  }
}

export default PoiStepSourceForm;



// WEBPACK FOOTER //
// ./src/components/PoiStepSourceForm/index.jsx